import styled from 'styled-components';

export const BoardContainer = styled.div`
    overflow: hidden;
    display: flex;
    position: relative;
`;